import { Controller } from '@hotwired/stimulus'

export default class Navbar extends Controller {
  static targets = ['submenu', 'arrow']

  toggle () {
    this.submenuTarget.classList.toggle('submenu-hidden')
    this.arrowTarget.classList.toggle('rotate-180')
  }
}
